import React from 'react';
import { ButtonWithIcon } from '@blueprint/ui';
import { Props } from '@blueprint/button/dist/Button.types';

import { LoaderIcon } from './LoaderIcon';

interface ButtonWithLoadingProps extends Props {
    isLoading?: boolean;
    loadingText?: string;
}

export const ButtonWithLoading: React.FC<
    ButtonWithLoadingProps & JSX.IntrinsicElements['button']
> = ({ isLoading, loadingText = 'Loading', children, ...props }) => (
    <ButtonWithIcon aria-live="polite" {...props}>
        {isLoading ? (
            <>
                <LoaderIcon data-testid="spinner-icon" aria-hidden />
                {loadingText}
            </>
        ) : (
            children
        )}
    </ButtonWithIcon>
);
